"use strict";
/*
 * Created on 8.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");

var LockActionResultType_1 = require("./LockActionResultType");
/**
 * @author MSu
 */


var LockActionResult =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(LockActionResult, _DomainObject_1$Domai);

  // noinspection TsLint
  function LockActionResult(resultType, lockOwner) {
    var _this;

    var sessionId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, LockActionResult);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LockActionResult).call(this));
    _this.resultType = resultType;
    _this.lockOwner = lockOwner;
    _this.sessionId = sessionId;
    return _this;
  }

  _createClass(LockActionResult, [{
    key: "isLocked",
    value: function isLocked() {
      return this.resultType === LockActionResultType_1.LockActionResultType.Locked || this.resultType === LockActionResultType_1.LockActionResultType.AlreadyLocked;
    }
  }, {
    key: "isLockedByUser",
    value: function isLockedByUser(user) {
      if (!this.isLocked()) {
        return false;
      }

      if (!this.lockOwner || !user) {
        return false;
      }

      return this.isLocked() && this.lockOwner.id === user.id;
    }
  }]);

  return LockActionResult;
}(DomainObject_1.DomainObject);

exports.LockActionResult = LockActionResult;

LockActionResult.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(LockActionResult.name);
  return {
    resultType: builder.senum('resultType', LockActionResultType_1.LockActionResultType, 'enums/lock-action-result-types'),
    lockOwner: builder.opt(builder.obj('lockOwner', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    })),
    sessionId: builder.opt(builder.id('sessionId'))
  };
}();